@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";

.wrapper {
    font-size: fontsOld.$medium;
    padding: 4px;
    margin: 4px;
    white-space: pre;
    height: 500px;
    overflow-y: scroll;
    resize: vertical;
    // The syntax palette is tuned for a white surface; on a dark background the key and
    // boolean hues all but vanish. Exposed as tokens with ui's values as inline fallbacks.
    border: 1px solid var(--code-block-border-color, #{colorsOld.$stoneLight});
    border-radius: 4px;

    :global {
        .string {
            color: var(--code-block-string-color, #{colorsOld.$emeraldDark});
        }

        .number {
            color: var(--code-block-number-color, #{colorsOld.$citrineDark});
        }

        .boolean {
            color: var(--code-block-boolean-color, #{colorsOld.$sapphireDark});
        }

        .null {
            color: var(--code-block-null-color, #{colorsOld.$rubyDark});
        }

        .key {
            color: var(--code-block-key-color, #{colorsOld.$stoneDarkX1});
        }
    }
}